// moz667: por culpa de vrdemo
var $ = jQuery;

require("./popovers.js");
require("./one2one-request-form.js");
require("./datepicker.js");
require("./autocomplete.js");

var $modal = $(
    '<div id="modalAjax" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="overflow-y:visible;">' +
    '<div class="modal-dialog modal-xl">' +
    '<div class="modal-content">' +
        '<div class="modal-header">' +
            '<h5 class="modal-title" id="modalAjaxLabel"></h5>' +
            '<button type="button" class="close" data-dismiss="modal" aria-label="Cerrar"><span aria-hidden="true">&times;</span></button>' +
        '</div>' +
        '<div class="modal-body">' +
        '<img src="' + N2M.HEAD_LOGO + '" alt="' + N2M.EVENT_TITLE + '" class="img-fluid logotipo" />' +
        '<div class="modal-body-content"></div>' +
        '</div>' +
        '<div class="modal-footer">' +
            '<button type="button" class="btn btn-secondary" data-dismiss="modal">' + n2m_i18n("Cancelar") + '</button>' +
        '</div>' +
    '</div></div></div>');


window.load_ajax_content = function(url_ajax_content, modal_title, modal_css_class) {
    $(".modal").modal("hide");
    
    $modal.addClass(modal_css_class);

    var $modal_body_content = $modal.find('.modal-body-content');
    $modal.find(".modal-title").html(modal_title);

    $( document ).ajaxError(function( event, jqxhr, settings, thrownError ) {
        // TODO: Quitar estas trazas una vez este estable el tema
        console.log(event);
        console.log(jqxhr);
        console.log(settings);
        console.log(thrownError);
        console.log("Error al cargar el contenido de : " + settings.url);
    });

    $modal_body_content.load(url_ajax_content, function(html) {
        $modal.off('show.bs.modal').on('show.bs.modal', function (modal_show_event) {
            setTimeout(function() {
                init_on_load_html();
            }, 500);
        }).off('hide.bs.modal').on("hide.bs.modal", function (modal_hide_event) {
            $modal.find('.modal-body-content').html("");
            $modal.modal('dispose');
            $modal.data('bs.modal', null);
            $modal.remove();
            $("body").removeClass("modal-open");
            $("body").css("padding-right", 0);
            $(".modal-backdrop ").remove();
        }).modal("show");
    });
};

function init_on_load_html() {
    activate_popovers();
    datepicker_init();
    autocomplete_init();
    file_upload_init();
    // TODO: No funciona el modal de one2one
    init_one2one_request_form();

}